import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { GameCardBody } from '../GameCardTooltip';
import styles from '../performanceStats.scss';

const SLIDE_SPEED_MS = 300;
const CENTER_PADDING = '24px';

function MatchCardCarousel({ entries, selectedIndex, onSelect, 'data-testid': dataTestId }) {
    const sliderRef = useRef(null);

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.slickGoTo(selectedIndex);
        }
    }, [selectedIndex]);

    const handleBeforeChange = (current, next) => {
        if (next !== selectedIndex) {
            onSelect(next);
        }
    };

    const sliderSettings = {
        dots: false,
        arrows: false,
        infinite: false,
        speed: SLIDE_SPEED_MS,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: CENTER_PADDING,
        // Mount directly on the selected (newest, last) card instead of
        // animating across from slide 0.
        initialSlide: selectedIndex,
        beforeChange: handleBeforeChange,
    };

    return (
        <div className={styles.matchCardCarousel} data-testid={dataTestId}>
            <Slider ref={sliderRef} {...sliderSettings}>
                {entries.map((entry, entryIndex) => {
                    const cardKey = entry.card.id ?? entryIndex;
                    const isSelected = entryIndex === selectedIndex;
                    return (
                        <div key={`match-card-${cardKey}`}>
                            <div
                                className={`${styles.matchCard} ${isSelected ? styles.matchCardSelected : ''}`}
                                data-testid={dataTestId && `${dataTestId}.card-${cardKey}`}
                            >
                                <GameCardBody card={entry.card} data-testid={dataTestId && `${dataTestId}.card-${cardKey}`} />
                            </div>
                        </div>
                    );
                })}
            </Slider>
        </div>
    );
}

MatchCardCarousel.propTypes = {
    entries: PropTypes.arrayOf(PropTypes.shape({
        pointIndex: PropTypes.number,
        card: PropTypes.shape({}),
    })),
    selectedIndex: PropTypes.number,
    onSelect: PropTypes.func.isRequired,
    'data-testid': PropTypes.string,
};

MatchCardCarousel.defaultProps = {
    entries: [],
    selectedIndex: 0,
    'data-testid': null,
};

export default MatchCardCarousel;
